import { useGlobalState } from 'state/globalState'
import React, { ReactElement } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

export const AccountNotReadyRoute = () => {
  const { accountReady } = useGlobalState()

  return accountReady ? <Navigate to="/" /> : <Outlet />
}
